/*
 * File: PatientSearchApp.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/04/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the patient search main page
 */
import React from "react";
import PersonIcon from "@material-ui/icons/Person";
import { observer } from "mobx-react";
import PatientSearchPage from "./pages/PatientSearchPage";
import PatientCreatePage from "../demographics/patient_info/components/PatientCreatePage";
import UIStore from "../store/UIStore";
import UIFormDialog from "components/ui/UIFormDialog";
import PatientStore from "services/patients/store/PatientStore";
import PropTypes from "prop-types";
import UIFab from "components/ui/UIFab";
import { StoreContext } from "utils/useStore";

class PatientSearchApp extends React.Component {
  state = { newAccountFormOpen: false };
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.uiStore = UIStore.create();
  }

  get patientStore() {
    return this.context.getStore(PatientStore);
  }

  componentDidMount() {
    this.props.appStore.setTitle("Patient Search");
    this.props.appStore.setRightNav();
  }

  createAccount = () => {
    return (
      <PatientCreatePage
        parentCallBack={this.formCallBack}
        patient={this.patientStore.newPatient}
        toggleFormDialog={() => this.uiStore.toggleFormDialog}
        createNewAccount={true}
      />
    );
  };

  formCallBack = patientId => {
    this.props.history.push("/patients/" + patientId + "/patient_home");
  };

  // -----------------------------------------
  render() {
    return (
      <div>
        <PatientSearchPage {...this.props} />
        <UIFab
          icon={<PersonIcon />}
          handleClick={this.uiStore.toggleFormDialog}
          name={"New Account"}
        />

        <UIFormDialog
          open={this.uiStore.showFormDialog}
          toggleDialog={this.uiStore.toggleFormDialog}
          title="Add Patient in New Account"
          viewPage={() => this.createAccount()}
        />
      </div>
    );
  }
}

PatientSearchApp.propTypes = {
  appStore: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default observer(PatientSearchApp);
